import teaInit, { sendTeaCommEvent, teaConfig } from 'lib/tea-analyze'
import { logger, metrics } from 'lib/slardar-utils'

interface IRealUser {
  scr?: number // 是否有过滚动
  clk?: number // 是否有过点击
}

export function isRealUser() {
  const realUser = getRealUserFromStorage()
  return realUser?.clk || realUser?.scr ? true : false
}

export function getRealUserFromStorage() {
  let realUser: IRealUser = null!
  let str = ''
  if (localStorage?.getItem) {
    str = localStorage.getItem('pc_real_user') ?? ''
  }
  try {
    realUser = JSON.parse(str ?? '')
  } catch (e) {
    // do nothing
  }
  return realUser
}

export function setRealUser2Storage({ scr, clk }: IRealUser) {
  const realUser = getRealUserFromStorage() ?? {}
  if (typeof scr !== 'undefined') {
    Object.assign(realUser, {
      scr,
    })
  }
  if (typeof clk !== 'undefined') {
    Object.assign(realUser, {
      clk,
    })
  }
  try {
    localStorage.setItem('pc_real_user', JSON.stringify(realUser))
  } catch (e) {
    if (metrics?.counter) {
      metrics.counter('pc_real_user_localstorage')
    }
  }
}

export default function init() {
  const isValidUser = isRealUser()

  let hasScroll = false
  let hasClick = false

  // 用户有效性，通过滚动实现
  let timer = 0
  function handleScroll() {
    if (timer) {
      window.clearTimeout(timer)
    }

    function winScroll() {
      sendTeaCommEvent('page_scroll', {})

      if (isValidUser || hasScroll) {
        return
      }

      hasScroll = true

      if (hasScroll) {
        setRealUser2Storage({ scr: 1 })
      }
    }

    timer = window.setTimeout(winScroll, 200)
  }

  function handleClick() {
    if (isValidUser || hasClick) {
      return
    }

    hasClick = true

    if (hasClick) {
      setRealUser2Storage({ clk: 1 })
    }
  }

  document.removeEventListener('scroll', handleScroll, false)
  document.addEventListener('scroll', handleScroll, false)

  if (!isValidUser) {
    document.removeEventListener('click', handleClick, false)
    document.addEventListener('click', handleClick, false)
  }

  return () => {
    document.removeEventListener('scroll', handleScroll, false)
    if (!isValidUser) {
      document.removeEventListener('click', handleClick, false)
    }
  }
}
